import genererFace from '@/services/gabed/face/genererFace';
import fillFaceWithData from '@/services/import/patrimoine/generation/face/fillFaceWithData';

export default function generationFace(ligneFace) {
  const face = genererFace();
  return fillFaceWithData(face, ligneFace);
}
